import React, { useState } from "react";
import '../css_components/ContactForm.css';
// import printingImg from '/img/about_us_1.jpg'; // replace with actual print-related image


const initial = { firstName: "", lastName: "", phone: "", email: "", message: "" };

const ContactUs = () => {
	const [values, setValues] = useState(initial);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [serverError, setServerError] = useState("");

  const onChange = (e) => {
    const { name, value } = e.target;
    setValues((v) => ({ ...v, [name]: value }));
  };

  const validate = () => {
    const e = {};
    if (!values.firstName.trim()) e.firstName = "First name is required";
    else if (!/^[A-Za-z\s'.-]{2,}$/.test(values.firstName)) e.firstName = "Enter a valid first name";

    if (!values.lastName.trim()) e.lastName = "Last name is required";
    else if (!/^[A-Za-z\s'.-]{2,}$/.test(values.lastName)) e.lastName = "Enter a valid last name";

    if (!values.phone.trim()) e.phone = "Phone number is required";
    else if (!/^[+\d][\d\s\-()]{9,}$/.test(values.phone)) e.phone = "Enter a valid phone";

    if (!values.email.trim()) e.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) e.email = "Enter a valid email";

    if (!values.message.trim()) e.message = "Message is required";
    else if (values.message.trim().length < 10) e.message = "Message should be at least 10 characters";

    return e;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setServerError("");
    const v = validate();
    setErrors(v);
    if (Object.keys(v).length) return;

    try {
      setSubmitting(true);
    //   const res = await fetch("/api/contact", {
    //     method: "POST",
    //     headers: { "Content-Type": "application/json" },
    //     body: JSON.stringify(values),
    //   });
    //   const data = await res.json().catch(() => ({}));
    //   if (!res.ok || data.ok === false) throw new Error(data?.error || "Failed to send your message");
      setSent(true);
      setValues(initial);
    } catch (err) {
      setServerError(err.message || "Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  if (sent) {
    return (
      <div className="contact-success" role="status" aria-live="polite">
        <div className="contact-success-card">
          <div className="check">✓</div>
          <h4>Thanks! We’ve received your message.</h4>
          <p>We’ll contact you shortly.</p>
          <button className="submit-btn" onClick={() => setSent(false)}>Send another message</button>
        </div>
      </div>
    );
  }


  return (


	<>

	<main>

<div className='contact' style={{backgroundColor: "#b9b3af"}}>
<div class="card">
  
  <div class="row">
					<div class="booking-form">
						<div class="booking-bg">
							<div class="form-header">
								<h2>Connect with Us</h2>
<p>Have a design in mind or need help with your print project? Reach out to <br></br>Inkmudra for personalized<br/> assistance, expert advice, and <br/> premium printing solutions. Let’s bring your ideas to life!</p>

							</div>
						</div>
						<form onSubmit={onSubmit} noValidate>
						<div className="row">
							<div className="col-6 col-md-6">
							<div className="form-group">
								<span className="form-label">First Name</span>
								<input
								className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
								type="text"
								name="firstName"
								value={values.firstName}
								onChange={onChange}
								required
								/>
								{errors.firstName && <div className="invalid-feedback">{errors.firstName}</div>}
							</div>
							</div>
							<div className="col-6 col-md-6">
							<div className="form-group">
								<span className="form-label">Last Name</span>
								<input
								className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
								type="text"
								name="lastName"
								value={values.lastName}
								onChange={onChange}
								required
								/>
								{errors.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
							</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md-12">
							<div className="form-group">
								<span className="form-label">Phone Number</span>
								<input
								className={`form-control ${errors.phone ? "is-invalid" : ""}`}
								type="tel"           /* better than number for + and leading zeros */
								inputMode="tel"
								name="phone"
								value={values.phone}
								onChange={onChange}
								required
								/>
								{errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
							</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md-12">
							<div className="form-group">
								<span className="form-label">Email Address</span>
								<input
								className={`form-control ${errors.email ? "is-invalid" : ""}`}
								type="email"
								name="email"
								value={values.email}
								onChange={onChange}
								required
								/>
								{errors.email && <div className="invalid-feedback">{errors.email}</div>}
							</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md-12">
							<div className="form-group">
								<span className="form-label">Message</span>
								<textarea
								className={`form-control ${errors.message ? "is-invalid" : ""}`}
								name="message"
								rows={5}
								style={{ height: "100px", lineHeight: "1.5" }}
								value={values.message}
								onChange={onChange}
								required
								/>
								{errors.message && <div className="invalid-feedback">{errors.message}</div>}
							</div>
							</div>
						</div>

						{serverError && <div className="alert alert-danger py-2">{serverError}</div>}

						<div className="form-btn">
							<button className="submit-btn" type="submit" disabled={submitting}>
							{submitting ? "Sending..." : "Send Message"}
							</button>
						</div>
						</form>
					</div>
				</div>
</div>
<div class="accents">
  <div class="acc-card"></div><div class="acc-card"></div><div class="acc-card"></div>
  <div class="light"></div><div class="light sm"></div>
</div>
</div>
</main>
	
	
	</>
    

  );
};

export default ContactUs;
